// Debug-only console output, gated by ercData.settings.dev_mode (owner site + Development Mode on).
// Keeps production/live-key consoles clean while preserving console.error for real failures.
function isDevMode() {
  return !!window.ercData?.settings?.dev_mode;
}

export function dlog(...args) {
  if (isDevMode()) console.log(...args);
}

export function dwarn(...args) {
  if (isDevMode()) console.warn(...args);
}
